import React, { useContext, useLayoutEffect, useRef, useState } from 'react';

import DataGrid from './DataGrid/DataGrid';
import ProjectInfo from './ProjectInfo';
import { useIsSmall } from '../../../../Components/Context/Hooks/mediaQueries';
import Branding from '../../../../Components/UI/Branding';
import OverflowingFlexBox from '../../../../Components/UI/OverflowingFlexBox';
import { assertErrors } from '../../../../Utils/errors';
import useGlobalContext, { ProjectContext } from '../../Context';
import styles from '../../styles.css';

interface ProjectsDetailProps {
  defaultLanguage?: string | null;
  error: Error;
}

const ProjectsDetail: React.FC<ProjectsDetailProps> = ({ defaultLanguage, error }) => {
  const isSmall = useIsSmall();
  const { project } = useContext(ProjectContext);
  const { type } = useGlobalContext();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useLayoutEffect(() => {
    const container = scrollRef.current;
    if (!container) {
      return;
    }

    setIsScrollable(container.scrollWidth !== container.clientWidth);
  }, []);

  if (!project) {
    assertErrors(error);
  }

  return (
    <>
      <OverflowingFlexBox ref={scrollRef}>
        {isSmall && <ProjectInfo />}

        <DataGrid isScrollable={isScrollable} />

        <Branding className={styles['sticky-branding']} language={defaultLanguage} type={type} />
      </OverflowingFlexBox>
    </>
  );
};

export default ProjectsDetail;
